import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { DealerFiveStarAwards } from 'site-modules/dealerships/components/dealer-five-star-awards/dealer-five-star-awards';

import './dealer-header-title.scss';

export function DealerHeaderTitleUI({ dealerName, fiveStarDealerAward, isMobile }) {
  const hasFiveStarDealerAward = !!(fiveStarDealerAward && fiveStarDealerAward.length);

  return (
    <div className="dealer-header-title container d-flex flex-column align-items-center justify-content-center h-100">
      <h1
        className={classNames('header-title text-center text-white mb-1_5 fw-bold', {
          'size-48': !isMobile,
          'size-36': isMobile,
        })}
      >
        {dealerName}
      </h1>
      {hasFiveStarDealerAward && <DealerFiveStarAwards years={fiveStarDealerAward} />}
    </div>
  );
}

DealerHeaderTitleUI.propTypes = {
  dealerName: PropTypes.string,
  fiveStarDealerAward: PropTypes.arrayOf(PropTypes.number),
  isMobile: PropTypes.bool,
};

DealerHeaderTitleUI.defaultProps = {
  dealerName: '',
  fiveStarDealerAward: [],
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const DealerHeaderTitle = connect(mapStateToProps)(DealerHeaderTitleUI);
